const data = {
	"width": 24,
	"height": 24,
	"body": "<g id=\"evaPersonDoneOutline0\"><g id=\"evaPersonDoneOutline1\"><path id=\"evaPersonDoneOutline2\" fill=\"currentColor\" d=\"M21.66 4.25a1 1 0 0 0-1.41.09l-1.87 2.15l-.63-.71a1 1 0 0 0-1.5 1.33l1.39 1.56a1 1 0 0 0 .75.33a1 1 0 0 0 .74-.34l2.61-3a1 1 0 0 0-.08-1.41ZM10 11a4 4 0 1 0-4-4a4 4 0 0 0 4 4Zm0-6a2 2 0 1 1-2 2a2 2 0 0 1 2-2Zm0 8a7 7 0 0 0-7 7a1 1 0 0 0 2 0a5 5 0 0 1 10 0a1 1 0 0 0 2 0a7 7 0 0 0-7-7Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;
